<template>
  <div id="vk_groups" class="vk-widget" :key="$core.breakpoint.width"></div>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  name: "WidgetVk",
  watch: {
    "$core.breakpoint.width": {
      handler: "initVk"
    }
  },
  mounted() {
    this.initVk();
  },
  methods: {
    initVk: debounce(function() {
      this.$nextTick(() => {
        window.VK.Widgets.Group(
          "vk_groups",
          {
            mode: 4,
            wide: 1,
            width: "'auto'",
            height: "626"
          },
          112775778
        );
      });
    }, 150)
  }
};
</script>

<style lang="scss">
.vk-widget {
  filter: drop-shadow(0 0 10px rgba(colors(palette-3), 0.3));
}
</style>
